"use client"

import { useEffect, useRef } from "react"
import Chart from "chart.js/auto"

const RadarChart = ({ scores }) => {
  const chartRef = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy()
    }

    const ctx = chartRef.current.getContext("2d")

    const labels = Object.keys(scores).map((key) => key.replace(/([A-Z])/g, " $1").trim())
    const data = Object.values(scores)

    chartInstance.current = new Chart(ctx, {
      type: "radar",
      data: {
        labels: labels,
        datasets: [
          {
            label: "GTM Assessment Score",
            data: data,
            backgroundColor: "rgba(8, 145, 178, 0.2)",
            borderColor: "rgba(8, 145, 178, 1)",
            borderWidth: 2,
            pointBackgroundColor: data.map((score) => {
              if (score >= 67) return "#10b981"
              if (score >= 34) return "#eab308"
              return "#dc2626"
            }),
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointRadius: 6,
            pointHoverRadius: 8,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          r: {
            beginAtZero: true,
            max: 100,
            min: 0,
            ticks: {
              stepSize: 20,
              font: {
                size: 12,
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
            angleLines: {
              color: "rgba(0, 0, 0, 0.1)",
            },
            pointLabels: {
              font: {
                size: 14,
                weight: "bold",
              },
              color: "#374151",
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const score = context.parsed.r
                let level = "Needs Improvement"
                if (score >= 67) level = "Strong"
                else if (score >= 34) level = "Moderate"
                return `Score: ${score} (${level})`
              },
            },
          },
        },
        elements: {
          line: {
            tension: 0.1,
          },
        },
      },
    })

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
      }
    }
  }, [scores])

  return (
    // <div className="w-full max-w-lg mx-auto">
    <div className="w-full mx-auto">
      <canvas ref={chartRef} width="768" height="768"></canvas>
    </div>
  )
}

export default RadarChart
